export default "__VITE_ASSET__BPROCDYG__"